module.exports = __webpack_public_path__ + "tv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tv.svg
// module id = 855
// module chunks = 0